<template>
  <div>
    <v-dialog
      v-for="item in items"
      :key="item.index"
      v-model="item.dialog"
      v-bind="item.dialogOptions"
      @click:outside="$eventBus.$emit('CLICK_OUTSIDE_MODAL')"
    >
      <component
        :is="item.component"
        @input="item.handleInput"
        v-bind="item.scope"
        v-bind:value="item.scope.model || item.scope.value"
        v-on="item.handlers"
      />
    </v-dialog>
  </div>
</template>

<script>
export default {
  data () {
    return {
      defaultItem: {
        dialog: true,
        scope: {},
        options: {},
        handlers: {},
        component: null
      },
      items: [],
      defaultOptions: {
        maxWidth: 300
      }
    }
  },
  created () {
    this.$eventBus.$on('OPEN_MODAL', this.handleOpenModalEvent)
    this.$eventBus.$on('CLOSE_MODAL', this.handleCloseModalEvent)
  },
  computed: {
    dialogOptions () {
      return { ...this.defaultOptions, ...this.options }
    }
  },
  methods: {
    handleOpenModalEvent (payload) {
      this.items.push({
        ...this.defaultItem,
        ...payload,
        dialogOptions: { ...this.defaultOptions, ...payload.options },
        handleInput: this.handleInput(this.items.length),
        index: this.items.length
      })
    },
    handleCloseModalEvent () {
      this.items.pop()
    },

    handleInput (index) {
      return (value) => {
        const item = this.items.find(i => i.index === index)
        if (item && 'model' in item.scope) {
          item.scope.model = value
        }
      }
    }
  }
}
</script>
